export const GOOGLE_CAPTCHA_SITE_KEY = '6Ldw8ugUAAAAAMrsBAAkVDtlg32NiuJLtAqNxRBW';
